import { Tabs, TabsContent } from '@monksflow/monks-ui';
import { UnderlineTabsList, UnderlineTabsTrigger } from '@/shared/ui';
import { type CompetitorTab, useAnalysisFormStore } from '../../../model/analysisFormStore';
import { CompetitorExtractFromDocumentTab } from './CompetitorExtractFromDocumentTab';
import { CompetitorCreateManuallyTab } from './CompetitorCreateManuallyTab';
import { DOCUMENT_EXTRACTION_TAB, CREATE_MANUALLY_TAB, TABS } from './constants';

export const CompetitorDefinitionTabs = () => {
  const activeTab = useAnalysisFormStore((s) => s.competitorTab);
  const setCompetitorTab = useAnalysisFormStore((s) => s.setCompetitorTab);

  return (
    <Tabs
      value={activeTab}
      onValueChange={(tab) => setCompetitorTab(tab as CompetitorTab)}
      className="gap-md"
    >
      <UnderlineTabsList>
        {TABS.map(({ value, label, icon: Icon }) => (
          <UnderlineTabsTrigger key={value} value={value}>
            <Icon className="size-md" />
            {label}
          </UnderlineTabsTrigger>
        ))}
      </UnderlineTabsList>
      <TabsContent value={DOCUMENT_EXTRACTION_TAB}>
        <CompetitorExtractFromDocumentTab />
      </TabsContent>
      <TabsContent value={CREATE_MANUALLY_TAB}>
        <CompetitorCreateManuallyTab />
      </TabsContent>
    </Tabs>
  );
};
